import { createFileRoute, Outlet } from '@tanstack/react-router'

import { requireRolesV2 } from '@/utils'

export const Route = createFileRoute(
  '/_private/dashboard/_base/transportadoras/_forms',
)({
  component: Outlet,
  beforeLoad: requireRolesV2({ allow: ["admin:root"] })
})
